import { useSelector } from 'react-redux'
import { selectIconColor } from '../slices/settingSlice'

const useIconInfo = () => {
  const iconColor = useSelector(selectIconColor)
  const iconSize = '1.4rem'

  return { iconColor, iconSize }
}

export default useIconInfo
